const WA = "https://wa.me/917995495312?text=Hi%20Aria%20—%20I'd%20like%20to%20book%20a%20free%20consultation";

const FinalCTA = () => {
  const goDemo = () => {
    const el = document.getElementById("demo");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section className="final-cta" data-bg="warm" data-testid="final-cta">
      <h2 className="final-cta-h2">
        Ready to build your<br />
        <span className="serif">AI-powered business</span>?
      </h2>
      <p className="final-cta-sub">
        Book a free consultation with Aria and discover where AI and automation
        can create immediate business value.
      </p>
      <div className="final-cta-buttons">
        <a href={WA} target="_blank" rel="noreferrer" className="btn btn-gold" data-testid="final-cta-wa">
          Book free consultation →
        </a>
        <button className="btn btn-outline-g" onClick={goDemo} data-testid="final-cta-demo">
          See live demo
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
